"use client";

import { api } from "@convex/_generated/api";
import { useQuery } from "convex/react";
import Link from "next/link";
import { WeaponBuildCard } from "@/app/weapons/builds/weapon-build-card";
import { Loader } from "@/components/loader";
import type { UserProfile } from "../utils";

interface WeaponBuildsSectionProps {
  profile: UserProfile;
}

export function WeaponBuildsSection({ profile }: WeaponBuildsSectionProps) {
  const weaponBuildsQuery = useQuery(api.users.queries.getUserWeaponBuilds, {
    userId: profile._id,
    paginationOpts: { numItems: 6, cursor: null },
  });

  if (weaponBuildsQuery === undefined) {
    return (
      <div className="flex justify-center py-12">
        <Loader />
      </div>
    );
  }

  const weaponBuilds = weaponBuildsQuery.page;

  if (weaponBuilds.length === 0) {
    return (
      <div className="py-12 text-center">
        <h3 className="mb-2 font-semibold text-xl">No weapon builds yet</h3>
        <p className="text-muted-foreground">
          {profile.username || "This user"} hasn't created any weapon builds
          yet.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {profile.stats.totalWeaponBuilds > 6 && (
        <div className="flex justify-end">
          <Link
            className="font-mono text-[#46C8E0] text-xs tracking-wider hover:text-[#7bd9ea]"
            href={`/weapons/builds?user=${profile.username || profile._id}`}
          >
            VIEW ALL →
          </Link>
        </div>
      )}

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {weaponBuilds.map((build) => (
          <WeaponBuildCard build={build} key={build._id} />
        ))}
      </div>
    </div>
  );
}
